import React, { FC, Fragment, Suspense } from 'react';
import { Text } from '@whitesharx/starfall-frontend-ui-kit';

import Flash from './components/Flash';
import ErrorBoundary from '../ErrorBoundary';
import { t } from '@whitesharx/starfall-frontend-ttranslate';
import GameLazy from './GameLazy';
import { GameProps } from './components/Game';

type Props = {
  shownFlash?: boolean;
  isInitialized: boolean;
  className: string;
};

const Ground: FC<Props & GameProps> = ({ shownFlash, isInitialized, className, ...gameProps }) => (
  <div className={className}>
    <Suspense fallback={<Fragment />}>
      <ErrorBoundary fallBack={<Text>{t('game.failed-to-load-the-board')}</Text>}>
        <GameLazy {...gameProps} />
      </ErrorBoundary>
    </Suspense>

    {!isInitialized && (
      <img
        src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOng9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCA4IDgiIHNoYXBlLXJlbmRlcmluZz0iY3Jpc3BFZGdlcyI+CjxnIGlkPSJhIj4KICA8ZyBpZD0iYiI+CiAgICA8ZyBpZD0iYyI+CiAgICAgIDxnIGlkPSJkIj4KICAgICAgICA8cmVjdCB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZSIgZmlsbD0iI2Y3ZTBiYiIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iMSIgaHJlZj0iI2UiIHg6aHJlZj0iI2UiLz4KICAgICAgICA8cmVjdCB5PSIxIiB3aWR0aD0iMSIgaGVpZ2h0PSIxIiBpZD0iZiIgZmlsbD0iI2IxODg2NSIvPgogICAgICAgIDx1c2UgeD0iMSIgeT0iLTEiIGhyZWY9IiNmIiB4OmhyZWY9IiNmIi8+CiAgICAgIDwvZz4KICAgICAgPHVzZSB4PSIyIiBocmVmPSIjZCIgeDpocmVmPSIjZCIvPgogICAgPC9nPgogICAgPHVzZSB4PSI0IiBocmVmPSIjYyIgeDpocmVmPSIjYyIvPgogIDwvZz4KICA8dXNlIHk9IjIiIGhyZWY9IiNiIiB4OmhyZWY9IiNiIi8+CjwvZz4KPHVzZSB5PSI0IiBocmVmPSIjYSIgeDpocmVmPSIjYSIvPgo8L3N2Zz4="
        className={className}
      />
    )}
    {shownFlash && <Flash show={shownFlash} />}
  </div>
);

export default Ground;
